import React from "react";
import ListItem from "./list-item/ListItem";
import { CategorySectionProps, EventPlatformEntry } from "@kaltura/mediaspace-shared-types";
import styled from "@emotion/styled";

export interface MediaListProps extends CategorySectionProps<EventPlatformEntry[]> {
    headingLevel?: "h2" | "h3";
}

const StyledContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        gap: theme.spacing(2),
    },
}));

/**
 * Category page media list section - entries which contain video
 */
const MediaList = ({ categoryId, content, additionalParams = {}, headingLevel = "h2" }: MediaListProps) => {
    const list = content.map((entry) => {
        const { name, description, duration, thumbnailUrl, id, customData = {} } = entry;
        return (
            <div key={"media-list-item_" + id} className={"kms-ds-channel-page-section-media-list-item"}>
                <ListItem
                    name={name}
                    description={description}
                    duration={duration}
                    image={thumbnailUrl}
                    entryId={id}
                    categoryId={categoryId}
                    customData={customData}
                    showSpeakers={
                        additionalParams["showSpeakersForContentTabEntries"]
                            ? additionalParams["showSpeakersForContentTabEntries"]
                            : false
                    }
                    headingLevel={headingLevel}
                />
            </div>
        );
    });
    return <StyledContainer className={"kms-ds-channel-page-section-media-list"}>{list}</StyledContainer>;
};

export default MediaList;
